<footer>
  @if (systemParamsService.logo()) {
    <img
      [src]="systemParamsService.logo()"
      alt="department logo"
      class="logo"/>
  } @else {
    <img src="./assets/light-logo.png" alt="department logo" class="logo">
  }
  <p>Copyright &copy; 2025 Australian Government - {{ systemParamsService.name() }} (<span class="environment">{{ environment() }}</span>) </p>
</footer>
